import React from 'react';
import { ICO_MOON } from 'src/common/constants';
import Col from '../Col';
import FontAwesomeIcon from '../Icon';
import Row from '../Row';
import Tile from '../Tile';
import IcoMoon from '../IcoMoon';

interface WizardTilesProps {
  onClose: () => void;
  onChange: (tile: any) => void;
  tiles: string[];
}

const WizardTiles = ({ onClose, onChange, tiles }: WizardTilesProps) => (
  <div className="wizard">
    <div className="wizard__header">
      <button onClick={() => onClose()} className="wizard__dismiss">
        <FontAwesomeIcon weight="light" glyph="times" />
      </button>
    </div>
    <div className="wizard__body">
      <div className="wizard__title">Create New</div>
      <Row mdCenter>
        <Col xs="12" md="8">
          <Row>
            {tiles.map((tile) => (
              <Col key={tile} xs="6" md="3">
                <Tile
                  title={tile}
                  onClick={() => onChange(tile)}
                  icon={<IcoMoon glyph={ICO_MOON[tile]} />}
                  size={undefined}
                  active={undefined}
                />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  </div>
);

export default WizardTiles;
